import create from "zustand";
import { useRouterStore } from "./Router";
import { useSessionStore } from "./Session";

export type Article = {
  id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  sentAt: Date;
  coverImageUrl: string;
  subject: string;
  message: any;
  sender: {
    firstName?: string;
    lastName?: string;
    id?: string;
    profileImageUrl?: string;
  };
};

interface NewsState {
  latestArticle?: Article;
  currentArticle?: Article;
  currentOffset: number;
  articles: Article[];
  loadingNews: boolean;
  loadMoreNews: () => void;
  loadLatestNews: () => void;
  loadArticle: (id: string) => void;
}

export const useNewsStore = create<NewsState>()((set, get) => ({
  latestArticle: undefined,
  currentArticle: undefined,
  currentOffset: 0,
  articles: [],
  loadingNews: false,
  loadArticle: (id: string) => {
    const sessionStore = useSessionStore.getState();
    set({
      currentArticle: undefined,
    });

    var xhr = new XMLHttpRequest();
    xhr.open("GET", sessionStore.apiUrl + "/outbound/news/shared/" + id);
    if (sessionStore.session) {
      xhr.setRequestHeader("Api-Token", sessionStore.sdkKey);
      xhr.setRequestHeader("Gleap-Id", sessionStore.session.gleapId ?? "");
      xhr.setRequestHeader("Gleap-Hash", sessionStore.session.gleapHash ?? "");
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200 && xhr.responseText) {
        try {
          const data = JSON.parse(xhr.responseText);
          if (data) {
            set({
              currentArticle: data,
            });
          } else {
            useRouterStore.getState().setPage("");
          }
        } catch (exp) {
          useRouterStore.getState().setPage("");
        }
      }
    };

    xhr.send();
  },
  loadMoreNews() {
    get().loadLatestNews();
  },
  loadLatestNews() {
    const sessionStore = useSessionStore.getState();
    const offset = 0; // get().currentOffset;
    set({
      articles: [],
      loadingNews: true,
    });
    
    var xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      sessionStore.apiUrl + "/outbound/news/shared?offset=" + offset
    );
    if (sessionStore.session) {
      xhr.setRequestHeader("Api-Token", sessionStore.sdkKey);
      xhr.setRequestHeader("Gleap-Id", sessionStore.session.gleapId ?? "");
      xhr.setRequestHeader("Gleap-Hash", sessionStore.session.gleapHash ?? "");
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200 && xhr.responseText) {
        try {
          const data = JSON.parse(xhr.responseText);
          if (data) {
            set({
              articles: offset === 0 ? data : [...data, ...get().articles],
              currentOffset: offset + data.length,
              loadingNews: false,
            });

            if (offset === 0) {
              set({
                latestArticle: data.length > 0 ? data[0] : undefined,
              });
            }
          }
        } catch (exp) { }
      }
    };

    xhr.send();
  },
}));
